import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import sanitizeHtml from 'sanitize-html';

import { URL } from '@/config/url';
import Watermark from '@/shared/assets/article-image-overlay.svg?svg';
import { EntityListArticleItem } from '@/shared/api/__generated__/models';
import { Box } from '@/shared/ui';
import * as ArticleComponents from '@/shared/ui/Article';
import { Text } from '@/shared/ui/Text';
import { formatArticleDate } from '@/shared/utils';
import { highlightToHTML } from '@/shared/utils/highlightToHtml';
import styles from './Article.module.css';

interface ArticleProps {
  article: EntityListArticleItem;
  highlight?: string;
  className?: string;
}

export const Article = ({ article, highlight, className }: ArticleProps) => {
  const {
    cover_url,
    title,
    publish_date,
    short_description,
    rubrics,
    slug,
    id,
  } = article;

  return (
    <Link
      className={clsx(styles.root, className)}
      href={URL.article(slug ?? id ?? '')}
    >
      <Box display="flex" flexDirection="column" gap={10} paddingY={4}>
        <ArticleComponents.ArticleDate>
          {formatArticleDate(publish_date ?? '')} · {rubrics?.[0]?.name}
        </ArticleComponents.ArticleDate>
        <Text
          className={styles.title}
          variant="primary"
          color="black"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(highlightToHTML(title ?? '', highlight ?? '')),
          }}
        />
        <ArticleComponents.ArticleDescription
          className={styles.description}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              highlightToHTML(short_description ?? '', highlight ?? '')
            ),
          }}
        />
      </Box>

      <div className={styles.imageWrapper}>
        <Image
          className={styles.image}
          width={200}
          height={112}
          src={cover_url ?? ''}
          alt="img"
          loading="lazy"
        />
        <Watermark className={styles.imageOverlay} />
      </div>
    </Link>
  );
};
